import { cn } from "../utils/cn";
import { Link } from "react-router-dom";
import { NavBarConnect } from "./NavBarConnect";
import { Logo } from "./Icons/Logo";
import { LogoVariant } from "./Icons/LogoVariant";

export enum BackgroundVariant {
  GRID = "grid",
  DOTS = "dots",
  NONE = "none",
}

export default function HeroSection({
  children,
  className,
  backgroundVariant = BackgroundVariant.GRID,
  backgroundClassName,
  maskClassName,
  afterClassName,
}: {
  children: React.ReactNode;
  className?: string;
  backgroundVariant?: BackgroundVariant;
  backgroundClassName?: string;
  maskClassName?: string;
  afterClassName?: string;
}) {
  return (
    <div
      className={cn(
        "h-full relative w-full bg-gradient-to-b from-black via-white/[0.025] to-black flex flex-col",
        className
      )}>
      {backgroundVariant === BackgroundVariant.GRID && (
        <div
          className={cn(
            "absolute inset-0",
            "[background-size:40px_40px]",
            "[background-image:linear-gradient(to_right,#111111_1px,transparent_1px),linear-gradient(to_bottom,#111111_1px,transparent_1px)]",
            backgroundClassName
          )}
        />
      )}
      {backgroundVariant === BackgroundVariant.DOTS && (
        <div
          className={cn(
            "absolute inset-0",
            "[background-size:20px_20px]",
            "[background-image:radial-gradient(#262626_1px,transparent_1px)]",
            backgroundClassName
          )}
        />
      )}
      <div
        className={cn(
          "pointer-events-none absolute inset-0 flex items-center justify-center [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)] bg-black",
          maskClassName
        )}
      />
      <div
        className={cn(
          "flex flex-col max-w-screen-2xl w-full mx-auto h-full z-10 px-3 2xl:px-0 overflow-hidden after:content-[''] after:pointer-events-none after:absolute after:inset-0 after:z-20 after:bg-[linear-gradient(to_bottom,transparent_75%,#000000_100%)]",
          afterClassName
        )}>
        <div className="flex justify-between items-center h-[64px] py-5 relative z-20">
          <Link to="/" className="h-full w-auto cursor-pointer">
            <Logo
              className="h-full w-auto hidden lg:block"
              variant={LogoVariant.DEFAULT}
            />
          </Link>
          <div className="items-center gap-x-4 hidden lg:flex">
            <NavBarConnect />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
